import UiReducer from './UiReducer';
import HomeReducer from './HomeReducer';
import TBOReducer from './TBOReducer';
import AIQReducer from './AIQReducer';
import UserReducer from './UserReducer';
import BusReducer from './BusReducer';
import EtravReducer from './EtravReducer';
import TripjackReducer from './TripjackReducer';
import HotelReducer from './HotelReducer';
import PackageReducers from './PackageReducer';
const rootReducer = {
	ui: UiReducer.reducer,
	home: HomeReducer.reducer,
	tbo: TBOReducer.reducer,
	aiq: AIQReducer.reducer,
	user: UserReducer.reducer,
	bus: BusReducer.reducer,
	etrav: EtravReducer.reducer,
	tripjack: TripjackReducer.reducer,
	hotel: HotelReducer.reducer,
	package: PackageReducers.reducer,
};

export default rootReducer;
